/* eslint-disable import/first */
import React, { useState, useEffect, useContext } from 'react';
import {
  Select,
  MenuItem,
  TextareaAutosize,
  Button,
  Grid,
  Typography,
  FormControl,
} from '@material-ui/core';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { feedBackReasons } = Slices.configSlice;
import { Context } from '../../components/Multi-lang/Wrapper';
import { FormattedMessage, useIntl } from 'react-intl';
import { BsChevronDown } from '@react-icons/all-files/bs/BsChevronDown';
import { userReviewsGA } from 'spwa-ui-library/esm/utils/helperGA';
import css from './index.module.scss';

const FeedbackForm = ({ submitFeedback, smileIndex, orderId, orderInfo = [] }) => {
  const [reason, setReason] = useState('');
  const [desc, setDesc] = useState('');
  const context = useContext(Context);
  const intl = useIntl();
  const theme = createMuiTheme({
    overrides: {
      MuiPopover: {
        root: {
          zIndex: '1400!important',
        },
      },
      MuiMenuItem: {
        root: {
          fontSize: '1.4rem ',
        },
      },
    },
  });
  const postFeedback = () => {
    const payload = {
      description: desc,
      rating: smileIndex,
      reason: reason,
      mdbOrderId: orderId || '',
    };
    submitFeedback(payload);
    // setDesc('');
    // setReason('');
    userReviewsGA(smileIndex, orderInfo);
  };
  const isFormFilled = () => {
    if (smileIndex === -1 && desc === '' && reason === '') {
      return false;
    } else if (smileIndex === -1 && reason !== '' && desc === '') {
      return false;
    } else {
      return true;
    }
  };

  const feedbackOptions = useSelector(feedBackReasons);
  const tellUsMore = intl.formatMessage({ id: 'feedback_textmessage' });

  return (
    <Grid className={css.root}>
      <Grid>
        <Typography className={css.requestText}>
          <FormattedMessage
            id="feedback_heading"
            defaultMessage="Your feedback is valuable to us. Tell us about your experience"
          />
        </Typography>
      </Grid>
      <FormControl className={css.formControl}>
        <Grid className={css.dropDown}>
          {/* <Grid>
            <Typography className={css.reasonHeader}>
              <FormattedMessage id="feedback_reason" defaultMessage="REASON" />
            </Typography>
          </Grid> */}
          <Grid className={css.formControl}>
            <ThemeProvider theme={theme}>
              <Select
                className={css.selectReason}
                IconComponent={BsChevronDown}
                displayEmpty
                key="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                <MenuItem value={''}>
                  <FormattedMessage id="feedback_select_reason" defaultMessage="Select Reason" />
                </MenuItem>
                {feedbackOptions[context.locale === 'en' ? 'En' : 'Ar']?.map((each, i) => {
                  return (
                    <MenuItem key={i} value={each}>
                      {each}
                    </MenuItem>
                  );
                })}
              </Select>
            </ThemeProvider>
          </Grid>
        </Grid>
        <Grid className={css.descriptionArea}>
          {/* <Grid>
            <Typography className={css.description}>
              <FormattedMessage id="feedback_desc" defaultMessage="Description" />
            </Typography>
          </Grid> */}
          <Grid className={css.descInput}>
            <TextareaAutosize
              className={reason === '' ? css.disablefeedbackText : css.feedbackTextArea}
              value={desc}
              onChange={(e) => setDesc(e.target.value)}
              lass={css.inputDescription}
              aria-label=""
              placeholder={tellUsMore}
            />
          </Grid>
        </Grid>

        <Grid className={reason === '' && desc === '' && css.warningText}>
          {desc.replace(/ /g, '') === '' && (
            <Typography className={css.provideReason}>
              <FormattedMessage
                id="feedback_error"
                defaultMessage="Please provide a reason as to what went wrong."
              />
            </Typography>
          )}
        </Grid>

        <Grid className={`${css.feedbackSubmit} ${reason !== '' && desc !== '' && css.buttonBox}`}>
          <Button
            className={isFormFilled() ? css.feedbackButton : css.fbdisableButton}
            onClick={postFeedback}
            // disabled={!isFormFilled()}
          >
            <FormattedMessage id="feedback_send" defaultMessage="SEND" />
          </Button>
        </Grid>
      </FormControl>
    </Grid>
  );
};

export default FeedbackForm;
